<template>
  <section
    class="my-8 mx-auto bg-black pt-6 px-2 md:px-10 pb-5 shadow-black shadow-xl max-w-[1400px]"
  >
    <RallyLogoDownload />

    <div class="flex flex-col gap-3 mt-6 text-center">
      <h1 class="font-russo text-2xl md:text-3xl font-normal text-white">
        What's New in Rally Navigator
      </h1>
      <h2 class="text-[#999999] font-helvetica text-[18px] md:text-[22px] font-semibold">
        Release Notes for the Rally Navigator Desktop App
      </h2>
    </div>

    <!-- Download: latest published version (read from the download server at
         build time, like the download page) + the system-detecting button. -->
    <div
      class="mt-6 mx-auto max-w-[800px] border-2 border-[#333333] rounded-lg px-4 md:px-8 pt-6 font-helvetica text-center"
    >
      <p class="text-[#999999] text-[15px] md:text-[17px]">
        Latest version
        <span class="text-white font-bold">{{ latestVersion }}</span>
        &middot; Released {{ releaseDate }}
      </p>
      <GuideDownloadCta />
      <p class="text-[#A9A9A9] text-[14px] md:text-[15px] pb-6 -mt-2">
        Already installed? Rally Navigator updates itself when you open it.
        Need the previous version or install help? See the
        <router-link to="/download" class="text-[#FF0000] hover:underline"
          >download page</router-link
        >.
      </p>
    </div>

    <!-- Release notes, newest first: versions newer than the hand-edited list come
         straight from the app's published notes; then src/content/releases.js. -->
    <div class="mt-10 mx-auto max-w-[900px] flex flex-col divide-y divide-[#333333] text-left">
      <article
        v-for="r in autoReleases"
        :id="anchor(r.version)"
        :key="r.version"
        class="py-8 font-helvetica"
      >
        <p v-if="r.releaseDate" class="text-[#999999] text-[14px] md:text-[15px]">
          {{ r.releaseDate }}
        </p>
        <h2 class="text-white text-[22px] md:text-[26px] font-bold mt-1">
          Version {{ r.version }}
        </h2>
        <template v-for="sec in r.sections" :key="sec.title">
          <h3 class="text-[#FF0000] text-[17px] md:text-[19px] font-bold mt-4">
            {{ sec.title }}
          </h3>
          <ul
            class="list-disc pl-6 mt-2 flex flex-col gap-2 text-[#DDDDDD] text-[16px] md:text-[18px]"
          >
            <li v-for="(item, i) in sec.items" :key="i">{{ item }}</li>
          </ul>
        </template>
      </article>
      <article
        v-for="r in releases"
        :id="anchor(r.version)"
        :key="r.version"
        class="py-8 font-helvetica"
      >
        <p class="text-[#999999] text-[14px] md:text-[15px]">
          <time :datetime="r.date">{{ longDate(r.date) }}</time>
        </p>
        <h2 class="text-white text-[22px] md:text-[26px] font-bold mt-1">
          Version {{ r.version }}
          <span class="text-[#FF0000]">&mdash; {{ r.headline }}</span>
        </h2>
        <ul
          class="list-disc pl-6 mt-4 flex flex-col gap-2 text-[#DDDDDD] text-[16px] md:text-[18px]"
        >
          <li v-for="(item, i) in r.items" :key="i">
            {{ item.text }}
            <router-link
              v-if="item.link"
              :to="item.link"
              class="text-[#FF0000] hover:underline whitespace-nowrap"
              >Learn more &rarr;</router-link
            >
          </li>
        </ul>
      </article>
    </div>

    <GuideDownloadCta />
    <RallyLogoDownload />
  </section>
</template>

<script>
import GuideDownloadCta from './GuideDownloadCta.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import { RELEASES, autoReleases } from '../content/releases';
// Generated at build time by scripts/fetch-version.js from the download server.
import appVersion from '../generated/app-version.json';

export default {
  name: 'WhatsNew',
  components: { GuideDownloadCta, RallyLogoDownload },
  data() {
    return {
      releases: RELEASES,
      autoReleases: autoReleases(),
      latestVersion: appVersion.version,
      releaseDate: appVersion.releaseDate,
    };
  },
  methods: {
    longDate(iso) {
      return new Date(`${iso}T12:00:00Z`).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    // "2.6.2 – 2.6.7" → "v2-6-2", so a release can be linked to directly.
    anchor(version) {
      return 'v' + version.split(' ')[0].replace(/\./g, '-');
    },
  },
};
</script>
